import { RTubes_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'

const Data = require('../json/TUBES.json')
//TUBE
function sortByMaterial(data: Array<RTubes_Type>) {
  return data.sort((a, b) => a.material.localeCompare(b.material))
}

export function fetchTubeGazMaterialList(): Array<{ value: string; label: string }> {
  var data: Array<{ value: string; label: string }> = []
  var filtered: Array<RTubes_Type> = Array.from(
    sortByMaterial(Data.filter((item: RTubes_Type) => item.type === 'GAZ'))
      .reduce((m, t) => m.set(t.material, t), new Map())
      .values()
  )
  filtered.map((item: RTubes_Type) => {
    data.push({ value: item.material, label: item.material })
  })

  return data
}

export function fetchTubeHydrauliqueMaterialList(): Array<{ value: string; label: string }> {
  var data: Array<{ value: string; label: string }> = []
  var filtered: Array<RTubes_Type> = Array.from(
    sortByMaterial(Data.filter((item: RTubes_Type) => item.type === 'HYDRAULIQUE'))
      .reduce((m, t) => m.set(t.material, t), new Map())
      .values()
  )
  filtered.map((item: RTubes_Type) => {
    data.push({ value: item.material, label: item.material })
  })
  return data
}

export function fetchTubeHydrauliqueDiametreSuperieur(diametre: number, material: string): RTubes_Type | null {
  const res = Data.filter((item: RTubes_Type) => item.type === 'HYDRAULIQUE' && item.material === material && item.diamInt >= diametre)
  if (res.length > 0) {
    return res[0]
  }
  return null
}

export function fetchTubeHydrauliqueByMaterial(): Array<{
  value: string
  label: string
  children: Array<{ value: string; label: string }>
}> {
  let data: Array<{
    value: string
    label: string
    children: Array<{ value: string; label: string }>
  }> = []
  var filtered: Array<RTubes_Type> = Array.from(
    sortByMaterial(Data.filter((item: RTubes_Type) => item.type === 'HYDRAULIQUE'))
      .reduce((m, t) => m.set(t.material, t), new Map())
      .values()
  )
  filtered.forEach((item: RTubes_Type) => {
    let res2 = Data.filter((item2: RTubes_Type) => {
      return item2.type === 'HYDRAULIQUE' && item2.material === item.material
    }).sort((a: RTubes_Type, b: RTubes_Type) => (a.diamInt > b.diamInt ? 1 : b.diamInt > a.diamInt ? -1 : 0))
    let dataMat: Array<{
      value: string
      label: string
    }> = []
    res2.forEach((item2: RTubes_Type) => {
      dataMat.push({ value: item2.uuid, label: item2.name })
    })
    data.push({ value: item.material, label: item.material, children: dataMat })
  })

  return data
}

export function fetchTube(uuid: string): RTubes_Type {
  return fetchGeneric(Data, uuid)
}

export function fetchTubeGazDiametreSuperieur(diametre: number, material: string): RTubes_Type | null {
  if (isNaN(diametre)) {
    return null
  }
  let gaz: Array<RTubes_Type> = Data.filter((item: RTubes_Type) => {
    return item.type === 'GAZ' && item.material === material && item.diamInt >= diametre
  }).sort((a: RTubes_Type, b: RTubes_Type) => (a.diamInt > b.diamInt ? 1 : b.diamInt > a.diamInt ? -1 : 0))

  if (gaz.length > 0) {
    return gaz[0]
  }
  return null
}

export function fetchI01TEMPATT(): Array<{
  value: string
  label: string
  children: Array<{ value: string; label: string }>
}> {
  var data: Array<{
    value: string
    label: string
    children: Array<{ value: string; label: string }>
  }> = []
  var filtered = ['Acier', 'Cuivre N1057', 'Inox EN10216-5', 'Polyéthylène', 'Polybutène', 'PVC']
  filtered.map((mat: string) => {
    let res2 = Data.filter((item: RTubes_Type) => item.type === 'HYDRAULIQUE' && item.material === mat && item.diamExt <= 28).sort(
      (a: RTubes_Type, b: RTubes_Type) => (a.diamInt > b.diamInt ? 1 : b.diamInt > a.diamInt ? -1 : 0)
    )
    var dataMat: Array<{ value: string; label: string }> = []
    res2.map((item2: RTubes_Type) => {
      dataMat.push({ value: item2.uuid, label: item2.name })
    })
    data.push({ value: mat, label: mat, children: dataMat })
  })
  return data
}
//S06

export function tubeAcierWithDiametre(diametre: number): RTubes_Type | null {
  if (isNaN(diametre)) {
    return null
  }
  let gaz: Array<RTubes_Type> = Data.filter(
    (item: RTubes_Type) => item.type === 'HYDRAULIQUE' && item.material === 'Acier' && item.diamInt >= diametre
  ).sort((a: RTubes_Type, b: RTubes_Type) => (a.diamInt > b.diamInt ? 1 : b.diamInt > a.diamInt ? -1 : 0))
  if (gaz.length > 0) {
    return gaz[0]
  }
  return null
}
